import { useMemo } from "react";

import { LtlDocumentsTenderModal } from "~/features/shipment-management/components/generate-ltl-documents-modal/index.tsx";
import {
	buildDocumentsAddressBookItems,
	buildDocumentsQuoteState,
} from "~/features/shipment-management/utils/shipment-quote-context-adapter.ts";
import type { Load } from "~/shared/schemas/loads-schema.ts";

type LoadGenerateDocumentsModalProps = {
	showModal: boolean;
	onToggleModal: () => void;
	load: Load;
};

// Builds the tender modal context straight from the load board row so the
// modal's View/Download/Send work exactly like the quoting tender modal.
export const LoadGenerateDocumentsModal = ({
	showModal,
	onToggleModal,
	load,
}: LoadGenerateDocumentsModalProps) => {
	const source = useMemo(
		() => ({
			quoteId: Number(load.quoteId) || 0,
			customerId: load.customerId ?? 0,
			poNumber: load.poNumber ?? 0,
			customerReference: load.customerPO ?? "",
			carrierName: load.ltlCarrierName ?? load.carrierName ?? null,
			totalQuantity: 1,
			pickup: {
				companyName: load.firstPickName,
				city: load.firstPickCity,
				stateProvince: load.firstPickState,
				postalCode: load.firstPickZIP,
			},
			delivery: {
				companyName: load.lastDropName,
				city: load.lastDropCity,
				stateProvince: load.lastDropState,
				postalCode: load.lastDropZIP,
			},
		}),
		[load],
	);

	const quoteState = useMemo(() => buildDocumentsQuoteState(source), [source]);
	const selectedAddressBookItems = useMemo(
		() => buildDocumentsAddressBookItems(source),
		[source],
	);

	return (
		<LtlDocumentsTenderModal
			onToggleModal={onToggleModal}
			quoteState={quoteState}
			selectedAddressBookItems={selectedAddressBookItems}
			showModal={showModal}
		/>
	);
};
